import { Injectable } from '@angular/core';

import { BaseStorage } from '../../core/abstractions/base.storage';
import { StorageTypeEnum } from '../../models/enums/storage-type.enum';
import { GateLogModel } from '../../models/gate-log.model';
import { OptionalType } from '../../models/types/optional.type';

@Injectable({
    providedIn: 'root'
})
export class GateStorage extends BaseStorage {
    private logsKey = 'logs';

    constructor() {
        super('gate', StorageTypeEnum.Session);
    }

    saveLogs(logs: GateLogModel[]): void {
        this.save(logs, this.logsKey);
    }

    getLogs(): OptionalType<GateLogModel[]> {
        return this.get<GateLogModel[]>(this.logsKey);
    }
}
